/**
 * API Error types
 * Standard error codes and types
 */

export enum ErrorCode {
  // Authentication errors (1000-1999)
  UNAUTHORIZED = 'UNAUTHORIZED',
  INVALID_TOKEN = 'INVALID_TOKEN',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  INSUFFICIENT_PERMISSIONS = 'INSUFFICIENT_PERMISSIONS',
  ACCOUNT_LOCKED = 'ACCOUNT_LOCKED',
  ACCOUNT_DELETED = 'ACCOUNT_DELETED',
  ACCOUNT_SUSPENDED = 'ACCOUNT_SUSPENDED',
  DELETION_CODE_EXPIRED = 'DELETION_CODE_EXPIRED',
  DELETION_CODE_INVALID = 'DELETION_CODE_INVALID',

  // Validation errors (2000-2999)
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  INVALID_INPUT = 'INVALID_INPUT',
  MISSING_REQUIRED_FIELD = 'MISSING_REQUIRED_FIELD',
  INVALID_FORMAT = 'INVALID_FORMAT',

  // Resource errors (3000-3999)
  NOT_FOUND = 'NOT_FOUND',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  RESOURCE_CONFLICT = 'RESOURCE_CONFLICT',

  // Business logic errors (4000-4999)
  OPERATION_NOT_ALLOWED = 'OPERATION_NOT_ALLOWED',
  QUOTA_EXCEEDED = 'QUOTA_EXCEEDED',
  RATE_LIMITED = 'RATE_LIMITED',
  SUBSCRIPTION_REQUIRED = 'SUBSCRIPTION_REQUIRED',

  // System errors (5000-5999)
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  DATABASE_ERROR = 'DATABASE_ERROR',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  EXTERNAL_SERVICE_ERROR = 'EXTERNAL_SERVICE_ERROR',

  // Tenant isolation errors (6000-6999)
  TENANT_MISMATCH = 'TENANT_MISMATCH',
  CROSS_TENANT_ACCESS = 'CROSS_TENANT_ACCESS',

  // SKU/Subscription limit errors (7000-7999)
  SKU_LIMIT_EXCEEDED = 'SKU_LIMIT_EXCEEDED',
  FEATURE_NOT_AVAILABLE = 'FEATURE_NOT_AVAILABLE',
  FILE_TYPE_NOT_ALLOWED = 'FILE_TYPE_NOT_ALLOWED',
  FILE_SIZE_EXCEEDED = 'FILE_SIZE_EXCEEDED',
  STORAGE_LIMIT_EXCEEDED = 'STORAGE_LIMIT_EXCEEDED',
}

export interface ErrorDetails {
  field?: string;
  value?: unknown;
  constraint?: string;
  expected?: string;
  existingBrandId?: string;
  existingBrandName?: string;
  // Allow additional properties for extensibility (e.g., onboarding, SKU errors)
  [key: string]: unknown;
}

export class AppError extends Error {
  constructor(
    public code: ErrorCode,
    public message: string,
    public statusCode: number = 500,
    public details?: ErrorDetails
  ) {
    super(message);
    this.name = 'AppError';
  }
}
